export default {
    TEXT: 0,
    NODE: 1,
    VIEW: 2
}